module.exports = __webpack_public_path__ + "static/img/aboutUs_phone.1fd92c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs_phone.png
// module id = Jeaq
// module chunks = 1